import { render, staticRenderFns } from "./IconBack.vue?vue&type=template&id=aec4e0ba&scoped=true&"
import script from "./IconBack.vue?vue&type=script&lang=js&"
export * from "./IconBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec4e0ba",
  null
  
)

export default component.exports